import { render, staticRenderFns } from "./VodStatisticsView.vue?vue&type=template&id=881d32b6&scoped=true"
import script from "./VodStatisticsView.vue?vue&type=script&lang=js"
export * from "./VodStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881d32b6",
  null
  
)

export default component.exports